import {useTranslation} from 'next-i18next';
import MobileOtpInput from 'react-otp-input';
import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import Input from '@/_application/core/components/ui/forms/input';
import Label from '@/_application/core/components/ui/forms/label';
import {useModalAction} from '@/_application/core/components/ui/modal/modal.context';
import {Form} from '@/_application/core/components/ui/forms/form';
import {Controller} from 'react-hook-form';
import type { OtpRegisterFormProps, OtpRegisterFormValues } from './otp-login.types';
import { otpLoginFormSchemaForNewUser } from './otp-login.schema';

export default function OtpRegisterForm({onSubmit, loading}: Readonly<OtpRegisterFormProps>) {
    const {t} = useTranslation('common');
    const {closeModal} = useModalAction();

    return (
        <div className="space-y-5 rounded border border-gray-200 p-5">
            <Form<OtpRegisterFormValues> onSubmit={onSubmit} validationSchema={otpLoginFormSchemaForNewUser}>
                {({register, control, formState: {errors}}) => (
                    <>
                        <Input
                            label={t('text-email')}
                            {...register('email')}
                            type="email"
                            variant="outline"
                            className="mb-5"
                            error={t(errors.email?.message!)}
                            aria-label="Email Input"
                        />
                        <Input
                            label={t('text-name')}
                            {...register('name')}
                            variant="outline"
                            className="mb-5"
                            error={t(errors.name?.message!)}
                            aria-label="Tên"
                        />

                        <div className="mb-5">
                            <Label>{t('text-otp-code')}</Label>
                            <Controller
                                control={control}
                                render={({field: {onChange, onBlur, value}}) => (
                                    <MobileOtpInput
                                        value={value}
                                        onChange={onChange}
                                        numInputs={6}
                                        separator={<span className="hidden sm:inline-block">-</span>}
                                        containerStyle="flex items-center justify-between -mx-2"
                                        inputStyle="flex items-center justify-center w-full! mx-2 sm:w-9! px-0! appearance-none transition duration-300 ease-in-out text-heading text-sm focus:outline-none focus:ring-0 border border-border-base rounded focus:border-accent h-12"
                                        disabledStyle="bg-gray-100!"
                                    />
                                )}
                                name="code"
                                defaultValue=""
                            />
                        </div>

                        <div className="grid grid-cols-2 gap-5">
                            <Button
                                variant="outline"
                                aria-label="Hủy"
                                className="hover:border-red-500 hover:bg-red-500"
                                onClick={closeModal}>
                                {t('text-cancel')}
                            </Button>

                            <Button
                                loading={loading}
                                disabled={loading}
                                aria-label="Xác minh mã"
                                className=" bg-primary uppercase hover:bg-blue-kid!">
                                {t('text-verify-code')}
                            </Button>
                        </div>
                    </>
                )}
            </Form>
        </div>
    );
}
